<div class="modal-wrapper" [ngClass]="{ 'dark-modal': isDarkMode() }">
  <div class="modal-header">
    <h2 mat-dialog-title>Column Visibility</h2>
    <mat-icon class="close-btn" (click)="onCancel()">close</mat-icon>
  </div>

  <mat-dialog-content class="modal-body custom-scroll">
    <div class="checkbox-grid">
      <div class="checkbox-item" *ngFor="let col of data.columns">
        <mat-checkbox
          [(ngModel)]="col.visible"
          [disabled]="col.fixed"
          color="primary"
        >
          <span class="check-label">{{ col.label }}</span>
        </mat-checkbox>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer">
    <button mat-button class="action-btn clear-btn" (click)="clearAll()">
      Reset All
    </button>
    <button mat-flat-button class="action-btn apply-btn" (click)="onApply()">
      Apply Changes
    </button>
  </mat-dialog-actions>
</div>
